const actions = {
  getRoles: async (context, { search, per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/roles`, {
      params: {
        search,
        per_page,
        page,
      },
    });

    return response;
  },
  getRolesPerson: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/roles/${id}`, {
      params: {
        per_page: 15,
      },
    });

    return response;
  },
  getPermissao: async (context, { nome, per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/permissions`, {
      params: {
        nome,
        per_page,
        page,
      },
    });

    return response;
  },
  ativarPermissao: async (context, { role_id, permission_ids }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/authorization/roles/${role_id}/attach-permissions`,
      {
        role_id,
        action: "attach-permissions",
        permission_ids,
      }
    );

    return response;
  },
  desativarPermissao: async (context, { role_id, permission_ids }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/authorization/roles/${role_id}/detach-permissions`,
      {
        role_id,
        action: "detach-permissions",
        permission_ids,
      }
    );

    return response;
  },
  criarRole: async (context, { description, display_name }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/authorization/roles`, {
      description,
      display_name,
    });

    return response;
  },
  getMachine: async (context, { vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/machine`, {
      params: {
        vendor_id,
      },
    });

    return response;
  },
  setMachine: async (
    context,
    { vendor_id, columns = 0, location, trays = 0, type }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/machine/store`, {
      vendor_id,
      columns,
      location,
      trays,
      type,
    });

    return response;
  },
  getUsers: async (context, { page, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users`, {
      params: {
        page,
        per_page,
        search,
      },
    });

    return response;
  },
  getAlertas: async (context, { userId }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/alert/from-logged-in-user`, {
      params: {
        userId,
      },
    });

    return response;
  },

  ativarAlerta: async (
    context,
    { optin, action, notification_id, user_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/alert/optin/${notification_id}`, {
      optin,
      action,
      notification_id,
      user_id,
    });

    return response;
  },

  desativarAlerta: async (
    context,
    { optin, action, notification_id, user_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/alert/optout/${notification_id}`, {
      optin,
      action,
      notification_id,
      user_id,
    });

    return response;
  },

  getMenu: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/menu`, {
      params: {
        per_page: 1000,
      },
    });

    return response;
  },

  setMenus: async (context, { menu_id, submenus }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/authorization/menu/${menu_id}/associar-submenus`,
      {
        menu_id,
        submenus,
      }
    );

    return response;
  },

  setRole: async (context, { menu_id, roles }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(
      `/authorization/menu/${menu_id}/associar-roles`,
      {
        menu_id,
        roles,
      }
    );

    return response;
  },

  getSubMenus: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/authorization/menu/submenus`, {
      params: {
        per_page: 1000,
      },
    });

    return response;
  },
  getUnidades: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },
  getUnidadesUser: async (context, { search = "" }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/users`, {
      params: {
        per_page: 100,
        search,
      },
    });

    return response;
  },
  auth: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`auth/me`);

    return response;
  },
  ativarUnidade: async (context, { vendor_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },
  deletarUnidade: async (context, { vendor_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },
};

export const adminMultpex = {
  namespaced: true,
  actions,
};
